import type { SVGProps } from 'react';

export const Check = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.958 6.481a.75.75 0 0 1 1.084 1.038l-9.507 9.92a.75.75 0 0 1-1.072.011L4.25 13.237a.75.75 0 0 1 1.061-1.06l3.671 3.67 8.976-9.366Z" />
    </svg>
  );
};
